export default __webpack_public_path__ + "static/media/PolycomEndUserLicenseAgreementALLPRODUCTS.c20ef14a.pdf";